const otherLocales = ['ko', 'ja'];
module.exports = {
  ns: ['common'],
  locales: ['en', ...otherLocales],
  defaultLocale: 'en',
  otherLocales,
};
